import { render } from "./Scoring.vue?vue&type=template&id=02052355"
import script from "./Scoring.vue?vue&type=script&lang=js"
export * from "./Scoring.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Scoring.vue?vue&type=style&index=0&id=02052355&lang=scss&module=s"
cssModules["s"] = style0
import "./Scoring.vue?vue&type=style&index=1&id=02052355&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__